import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { C } from '../../albumColors';
import { findSelectionMatches } from '../../albumData';

function SelectionMatchCard({ selected, myCounts, allUsers, tradeIndex, onViewUser, theme }) {
  const { t } = useTranslation();
  const { matches, wantCount, offerCount } = useMemo(
    () => findSelectionMatches(selected, myCounts, allUsers, tradeIndex),
    [selected, myCounts, allUsers, tradeIndex]
  );

  const headingText = theme?.cardHeadingText ?? C.onSurfaceVariant;
  const subtleText  = theme?.cardSubtleText  ?? C.outline;
  const bodyText    = theme?.cardBodyText    ?? C.onSurface;
  const rankText    = theme?.cardSubtleText  ?? C.outlineVariant;
  const hoverBg     = theme?.cardRowHoverBg  ?? C.surfaceContainerHigh;
  const accent      = theme?.primaryAccent   ?? C.primary;
  const accentDim   = theme?.mutedText       ?? C.primaryDim;
  const chevron     = theme?.cardSubtleText  ?? C.outlineVariant;

  if (selected.size === 0) return null;

  return (
    <section className="mb-8">
      <h4 className="text-xs font-bold uppercase tracking-widest mb-2" style={{ color: headingText }}>
        {t('Selection Match')}
      </h4>
      <p className="text-[10px] mb-3" style={{ color: subtleText }}>
        {wantCount > 0 && <><span className="font-bold" style={{ color: accent }}>{wantCount}</span> {t('you need')}</>}
        {wantCount > 0 && offerCount > 0 && ' · '}
        {offerCount > 0 && <><span className="font-bold" style={{ color: accentDim }}>{offerCount}</span> {t('to offer')}</>}
      </p>

      {matches.length === 0 ? (
        <p className="text-[10px]" style={{ color: subtleText }}>{t('No matches found for this selection')}</p>
      ) : (
        <div className="space-y-1.5">
          {matches.map(({ user, theyCanGive, theyNeed }, i) => (
            <a
              key={user.id}
              onClick={() => onViewUser(user, selected, { autoEnterMatch: true })}
              className="flex items-center gap-2.5 p-2 rounded-lg transition-all cursor-pointer"
              onMouseEnter={e => e.currentTarget.style.backgroundColor = hoverBg}
              onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}
            >
              <span className="text-[10px] font-black w-4 text-center" style={{ color: rankText }}>
                {i + 1}
              </span>
              <div
                className="w-7 h-7 rounded-full flex items-center justify-center text-white text-[10px] font-bold shrink-0"
                style={{ backgroundColor: user.color }}
              >
                {user.initial}
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-[11px] font-bold truncate" style={{ color: bodyText }}>{user.name}</p>
                <div className="flex items-center gap-2 text-[9px]">
                  {theyCanGive > 0 && (
                    <span style={{ color: '#B45309' }}>
                      <span className="font-bold">{theyCanGive}</span> {t('to give')}
                    </span>
                  )}
                  {theyNeed > 0 && (
                    <span style={{ color: accentDim }}>
                      <span className="font-bold">{theyNeed}</span> {t('needs')}
                    </span>
                  )}
                </div>
              </div>
              <span className="material-symbols-outlined text-sm" style={{ color: chevron }}>chevron_right</span>
            </a>
          ))}
        </div>
      )}
    </section>
  );
}

export default SelectionMatchCard;
